/**
 * 客户端push 添加、编辑板块
 */
"use strcit";
angular.module("clientPushManagementAddAndEditModule", [])
    .controller("clientPushManagementAddAndEditCtrl", ['$scope','selectedItem', 'trsHttpService', '$stateParams', '$q', '$modalInstance', "$validation", 'modalDialog', '$state', function ($scope,selectedItem, trsHttpService, $stateParams, $q, $modalInstance, $validation, modalDialog, $state) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                isShowClient: 0,
                createTitle:selectedItem==''?"添加":"编辑"
            };
            $scope.data = {
                title: '',
                remark: '',
                clientList: {},
                selectedClientList: [],
                clientInfo: {},
                clientIds: [],
            };

            $scope.params = {
                "serviceid": "clientlist",
                "modelid": "getClintInfoList",
                "typeid": "screen"
            };

            $scope.page = {
                CURRPAGE: 1,
                PAGECOUNT: 0,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
            };

            $scope.clientParams = {
                "serviceid": "appPushMgr",
                "typeid": "screen",
                "modelid": "search",
                "page_no": $scope.page.CURRPAGE - 1,
                "page_size": $scope.page.PAGESIZE,
                "id": selectedItem.ID,
            };
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            if(selectedItem!=''){
                $scope.data.title=selectedItem.TITLE;
                $scope.data.remark=selectedItem.REMARK;
            }
            requestData().then(function () {
                if (selectedItem.ID) {
                    getClientInfo();
                }
            });
        }
        //取消
        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
        /**
         * [matchingIds 匹配已选中的项目]
         * @param  {[type]} ids        [description]
         * @param  {[type]} clientList [description]
         * @return {[type]}            [description]
         */
        function matchingIds(ids, clientList) {
            for (var i = 0; i < ids.length; i++) {
                for (var key in clientList) {
                    for (var temp in clientList[key]) {
                        if (ids[i] == clientList[key][temp].appId) {
                            $scope.data.selectedClientList.push(clientList[key][temp]);
                        }
                    }
                }
            }
        }

        /**
         * [getClientInfo 获取单条客户端管理信息]
         * @return {[type]} [description]
         */
        function getClientInfo() {
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.clientParams, 'post').then(function (data) {
                $scope.data.clientInfo = data.MAPRESULT.content.CONTENT[0];
                $scope.data.title = $scope.data.clientInfo.TITLE;
                $scope.data.remark = $scope.data.clientInfo.REMARK;
                $scope.data.clientIds = $scope.data.clientInfo.CLIENTIDS.split(';');
                matchingIds($scope.data.clientIds, $scope.data.clientList);
                // for (var i = 0; i < $scope.data.clientIds.length; i++) {
                //     for (var key in $scope.data.clientList) {
                //         for (var temp in $scope.data.clientList[key]) {
                //             if ($scope.data.clientIds[i] == $scope.data.clientList[key][temp].appId) {
                //                 $scope.data.selectedClientList.push($scope.data.clientList[key][temp]);
                //             }
                //         }
                //     }
                // }
            });
        }

        /**
         * [requestData 获取客户端列表]
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function (data) {
                var stringArray = [];
                $scope.data.clientList = {};
                //将数据进行按首字母拼音进行排序
                stringArray = (function (data) {
                    data.sort(function (x, y) {
                        x.firstLetter = pinyinUtil.getFirstLetter(x.appName).substring(0, 1);
                        y.firstLetter = pinyinUtil.getFirstLetter(y.appName).substring(0, 1);
                        return x.firstLetter.charCodeAt(0) - y.firstLetter.charCodeAt(0);
                    });
                    return data;
                })(data);
                //将排序好的数据进行整合到对应的关联数组中
                var reg = /^[0-9]/;
                for (var i = 0; i < stringArray.length; i++) {
                    if (parseInt(stringArray[i].firstLetter) != 'NaN' && reg.test(parseInt(stringArray[i].firstLetter))) {
                        stringArray[i].firstLetter = '#';
                    }
                }
                for (var key in stringArray) {
                    if (!$scope.data.clientList[stringArray[key].firstLetter]) {
                        $scope.data.clientList[stringArray[key].firstLetter] = [];
                        $scope.data.clientList[stringArray[key].firstLetter].push(stringArray[key]);
                    } else {
                        $scope.data.clientList[stringArray[key].firstLetter].push(stringArray[key]);
                    }
                }
                return defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [save 保存]
         * @return {[type]} [description]
         */
        $scope.save = function () {
            $validation.validate($scope.addEditClientform).success(function () {
                var pattern=/[`~#$^&*_+<>"{}\/'【】[\]]/im;
                if(pattern.test($scope.data.title)){
                    modalDialog.alertType("填写项里包含特殊字符", "", "error", false);
                    return;
                }
                if ($scope.data.selectedClientList.length > 0) {
                    var params = {
                        "serviceid": "appPushMgr",
                        "modelid": "save",
                        "typeid": "screen",
                        "title": $scope.data.title,
                        "remark": $scope.data.remark,
                        "client_ids": formatData($scope.data.selectedClientList),
                    };
                    if (selectedItem.ID) params.id = selectedItem.ID;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                        if (data.MAPRESULT.status === "SUCCESS") {
                            modalDialog.alertType('保存成功', '', 'success', false, function() { $modalInstance.close("success");});
                        }
                    })
                } else {
                    modalDialog.alertType('提示信息', '分组选择时必须的!', 'warning', 'confirm', function () {
                        return;
                    });
                }
            }).error(function () {
                $scope.showAllTips = true;
                modalDialog.alertType("提交失败", "请检查表单", "info", false, function () {});
            });
        }

        /**
         * [formatData 格式化已选中的数组]
         * @return {[type]} [description]
         */
        function formatData(data) {
            var array = [];
            for (var key in data) {
                array.push(data[key].appId);
            }
            return array.join(';');
        }

        /**
         * [singleSelect 单选]
         * @param  {[type]} temp [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function (temp) {
            var n = $scope.data.selectedClientList.indexOf(temp);
            if (n > -1) {
                $scope.data.selectedClientList.splice(n, 1);
            } else {
                $scope.data.selectedClientList.push(temp);
            }
            $scope.status.isShowClient = 0;
        };

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function () {
            for (var key in $scope.data.clientList) {
                for (var temp in $scope.data.clientList[key]) {
                    if ($scope.data.selectedClientList.indexOf($scope.data.clientList[key][temp]) == -1) {
                        $scope.data.selectedClientList.push($scope.data.clientList[key][temp]);
                    }
                }
            }
            $scope.status.isShowClient = 1;
        }

        /**
         * [inverseElection 反选]
         * @return {[type]} [description]
         */
        $scope.inverseElection = function () {
            for (var key in $scope.data.clientList) {
                for (var temp in $scope.data.clientList[key]) {
                    var n = $scope.data.selectedClientList.indexOf($scope.data.clientList[key][temp]);
                    if (n > -1) {
                        $scope.data.selectedClientList.splice(n, 1);
                    } else {
                        $scope.data.selectedClientList.push($scope.data.clientList[key][temp]);
                    }
                }
            }
            $scope.status.isShowClient = 2;
        }
    }]).filter('filterName', function () {
        return function (temp) {
            var name;
            if (temp.indexOf('&nbsp;') > -1) {
                name = temp.replace('&nbsp;', ' ');
                return name;
            } else {
                return temp;
            }
        }
    });